export default "__VITE_ASSET__4a4c13ad__"